import { Controller } from '@hotwired/stimulus'
import { createApp } from 'vue'
import App from '~/javascript/components/dashboard/show.vue'

export default class extends Controller {
  static values = {
    mapKey: String
  }

  connect() {
    const props = {
      mapKey: this.mapKeyValue
    }
    this.vue = createApp(App, props)
    this.vue.mount(this.element)
  }

  disconnect() {
    this.vue?.unmount()
  }
}
